import { GENERIC_VOICING_DOTS } from "./chordCagedConstellation";

/** Micro-shape a partir de la forma real de la caja en el mástil (cuerda × traste). */
export function fingeringToConstellationDots(
  notes: ReadonlyArray<{ string: number; fret: number }>
): ReadonlyArray<{ top: number; left: number }> {
  if (notes.length === 0) return GENERIC_VOICING_DOTS;

  const minFret = Math.min(...notes.map((n) => n.fret));
  const maxFret = Math.max(...notes.map((n) => n.fret));
  const fretSpan = Math.max(maxFret - minFret, 1);

  return notes.map((n) => ({
    top: Math.round(((6 - n.string) / 5) * 16),
    left: Math.round(((n.fret - minFret) / fretSpan) * 18),
  }));
}
